import { Box } from '@chakra-ui/react'

/**
 * Extracts the name from an object or returns the value directly
 * @param value - Can be an object with a name property or a string/number
 * @returns The name if value is an object, otherwise the value itself
 */
export const extractName = (value: any): string => {
  if (typeof value === 'object' && value !== null) {
    return value.name || ''
  }
  return value || ''
}

/**
 * Creates a custom renderer for an object with name property
 * @param withBox - If true, wraps the name in a Box component with styling
 * @param maxWidth - Maximum width for the Box (default: '200px')
 * @returns A renderer function that can be used in customRenderers
 */
export const createNameRenderer = (
  withBox: boolean = false,
  maxWidth: string = '200px'
) => {
  return (value: any, row?: any) => {
    const name = extractName(value)
    
    if (withBox) {
      return (
        <Box
          maxW={maxWidth}
          wordBreak="break-word"
          whiteSpace="normal"
          overflowWrap="break-word"
        >
          {name}
        </Box>
      )
    }
    
    return name
  }
}
